// extracted by mini-css-extract-plugin
export default {"Home":"Home_Home__PduFw","HomeButtonRows":"Home_HomeButtonRows__2PDF0","HomeButton":"Home_HomeButton__DnBwg","Greeting":"Home_Greeting__fVguE","Occupation":"Home_Occupation__kSq4R"};